import React from "react";
import { useSelector } from "react-redux";
import { useCurrentShipmentType } from "../../hooks/useCurrentShipmentType";
import { selectDeclarationType } from "../selectors";
import { useGetCustomsOfficeDS } from "./useGetCustomsOfficeDS";


export const useValidateDepartModeUsingExitOffice=(mot='')=>{
    const {isImportShipment}=useCurrentShipmentType()
    const customOfficeList = useGetCustomsOfficeDS()
    const declarationEntryType=useSelector((state)=>selectDeclarationType(state))
      return React.useMemo(()=>{
        if(isImportShipment || customOfficeList.length==0)
            return false
        
         const response={}
                const isExistEXT=customOfficeList.filter(c=>c.type=="EXT" || c.type=="DEC")
                if(isExistEXT.length==2) // need to compare data which has type EXT OR DEC
                {
                const unique = [...new Set(isExistEXT.map(item => item.office))];
                if(unique.length>1)
                        if(!["D","E","F"].includes(declarationEntryType))  response.motValidationMsg="Declaration Customs Office <> Exit Office and DEC Type<>D, E or F → Departure Transport mode is required" 
                }
                  

        return response
      },[customOfficeList,declarationEntryType,isImportShipment,mot])

    
      
}